/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/timeline/Timeline.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import TimelineItem from './TimelineItem';
import { ConfigContext } from '../config-provider';
import { cloneElement } from '../_util/reactNode';
const Timeline = (props) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, pending = null, pendingDot, children, className, reverse = false, mode = '', ...restProps } = props;
    const prefixCls = getPrefixCls('timeline', customizePrefixCls);
    const pendingNode = typeof pending === 'boolean' ? null : pending;
    const [fold, setFold] = React.useState(props.fold || []);
    const pendingItem = pending ? (React.createElement(TimelineItem, { pending: !!pending, dot: pendingDot || React.createElement(LoadingOutlined, null) }, pendingNode)) : null;
    const timeLineItems = React.Children.toArray(children);
    timeLineItems.push(pendingItem);
    if (reverse) {
        timeLineItems.reverse();
    }
    const getPositionCls = (ele, idx) => {
        if (mode === 'alternate') {
            if (ele.props.position === 'right')
                return `${prefixCls}-item-right`;
            if (ele.props.position === 'left')
                return `${prefixCls}-item-left`;
            return idx % 2 === 0 ? `${prefixCls}-item-left` : `${prefixCls}-item-right`;
        }
        if (mode === 'left')
            return `${prefixCls}-item-left`;
        if (mode === 'right')
            return `${prefixCls}-item-right`;
        if (ele.props.position === 'right')
            return `${prefixCls}-item-right`;
        return '';
    };
    const toggleFoldFuc = (folderIndex, total) => {
        const foldDate = fold.map((item) => ({ ...item }));
        if (folderIndex) {
            for (let i = 0; i < foldDate.length; i++) {
                const { foldArea, foldShow } = foldDate[i];
                if ((foldArea[1] && folderIndex === foldArea[1]) || (!foldArea[1] && folderIndex === total - 1)) {
                    foldDate[i].foldShow = !foldShow;
                }
            }
            setFold(foldDate);
        }
    };
    // Remove falsy items
    const truthyItems = timeLineItems.filter((item) => !!item);
    const itemsCount = React.Children.count(truthyItems);
    const lastCls = `${prefixCls}-item-last`;
    // @ts-ignore
    const items = React.Children.map(truthyItems, (ele, idx) => {
        const pendingClass = idx === itemsCount - 2 ? lastCls : '';
        const readyClass = idx === itemsCount - 1 ? lastCls : '';
        let folderIndex = null;
        let foldNodeShow = false;
        fold.forEach((item) => {
            const { foldArea, foldShow } = item;
            if (foldArea[0] && idx >= foldArea[0] && (idx <= foldArea[1] || !foldArea[1])) {
                folderIndex = foldArea[1] || itemsCount - 1;
                foldNodeShow = foldShow;
            }
        });
        return cloneElement(ele, {
            className: classNames([
                ele.props.className,
                !reverse && !!pending ? pendingClass : readyClass,
                getPositionCls(ele, idx)
            ]),
            folderIndex: folderIndex,
            foldShow: foldNodeShow,
            index: idx,
            toggleFold: folderIndex === idx ? () => toggleFoldFuc(folderIndex, itemsCount) : () => { }
        });
    });
    // @ts-ignore
    const hasLabelItem = timeLineItems.some((item) => !!item?.props?.label);
    const classString = classNames(prefixCls, {
        [`${prefixCls}-pending`]: !!pending,
        [`${prefixCls}-reverse`]: !!reverse,
        [`${prefixCls}-${mode}`]: !!mode && !hasLabelItem,
        [`${prefixCls}-label`]: hasLabelItem,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className);
    return (React.createElement("ul", { ...restProps, className: classString }, items));
};
Timeline.Item = TimelineItem;
// const ConfiguredTimeline = withConfigProvider(Timeline);
// export { ConfiguredTimeline as Timeline };
// export default ConfiguredTimeline;
export default Timeline;
